var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.932,
    height: 26.769,
    viewBox: "0 0 21.932 26.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3, .cls-4 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #7d7d7d;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11281",
    "data-name": "Group 11281",
    transform: "translate(-196.25 -275.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10163",
    "data-name": "Group 10163",
    transform: "translate(200.702 294.159)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1110",
    "data-name": "Line 1110",
    className: "cls-1",
    y1: 6.841,
    x2: 3.237
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1111",
    "data-name": "Line 1111",
    className: "cls-1",
    x1: 3.437,
    y1: 6.841,
    transform: "translate(3.237)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1826",
    "data-name": "Ellipse 1826",
    className: "cls-2",
    cx: 1.964,
    cy: 1.964,
    r: 1.964,
    transform: "translate(206.032 282.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7145",
    "data-name": "Path 7145",
    className: "cls-3",
    d: "M14.323,11.446l5.5,4.658c.4.334.767.667,1.168,1,.5.434.033.7-.434.934a13.36,13.36,0,0,1-3.3,1.135A13.539,13.539,0,0,1,1.138,8.83,13.123,13.123,0,0,1,.871,4.558a10.615,10.615,0,0,1,.834-3.4c.3-.6.7-.067,1.068.234.467.4.934.8,1.435,1.235C5.543,3.757,7.2,5.3,8.536,6.435",
    transform: "translate(196.193 275.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7149",
    "data-name": "Path 7149",
    className: "cls-4",
    d: "M12.5,0a3.891,3.891,0,0,1,3.907,3.876",
    transform: "translate(195.162 280.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7150",
    "data-name": "Path 7150",
    className: "cls-4",
    d: "M18.3,0a5.681,5.681,0,0,1,5.719,5.643",
    transform: "translate(189.364 278.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7151",
    "data-name": "Path 7151",
    className: "cls-4",
    d: "M24.262,0a7.533,7.533,0,0,1,7.582,7.483",
    transform: "translate(183.4 276.507)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite .5da3deba665d8655ed09c2c0c178f8c9.svg";
export { ForwardRef as ReactComponent };